<!-- Ported from the Polaris kit: src/components/ui/number-field/NumberFieldInput.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port.
     Polaris patch (woot, phase 9.3): `reset-base`, so the app's global `input[type]` rule does not draw a second box
     (same patch as ui/input, phase P); a re-port drops it. -->
<script setup>
import { NumberFieldInput } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <NumberFieldInput
    data-slot="input"
    :class="
      cn(
        'reset-base flex h-9 w-full rounded-polaris-md border border-solid border-polaris-input bg-transparent py-1 type-polaris-body text-center shadow transition-colors placeholder:text-polaris-muted-foreground focus-visible:outline-none focus-visible:ring-[1px] focus-visible:ring-polaris-ring disabled:cursor-not-allowed disabled:opacity-50',
        props.class
      )
    "
  />
</template>
